import colors from '@/styles/colors';
import styled from 'styled-components';

export const SignInOptions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
`;

export const SignInFooter = styled.div`
  color: ${colors.hardGray};
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-top: 24px;

  a {
    margin-left: 3px;
  }
`;
